<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
            <v-layout row wrap align-center justify-center class="mt-2">
              
            <span class="headline font-weight-bold">Schedule a Review of Problem-Solution fit</span> 
              <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                <span>Tip: Customer pain points can change over time and the solution will need to evolve accordingly to stay relevant. Additionally, It might be a good idea to have a review of the problem-solution fit after some time, to see if the current solution concept is still the best option to resolve the customer pain points. These can be done after a 3 month, 6 month or 1 year window.
                       </span> 
                
              </v-alert>
              <!-- <v-btn flat small :href="linktolfwireframe" target="_blank" class="mx-2 font-weight-light" align-center justify-center>Learn more about Wireframes</v-btn>  -->
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                 <!-- <v-textarea
                  outline   
                  :rules="textInputRules"
                  :label="handlingscaleLabel"
                  v-model="handlingscaledetails"
                  
                >
                 </v-textarea>  -->
                
                <v-menu>
                    <v-text-field slot="activator" label="Pick a date" hint="Select a date for the Problem-Solution fit review" :value="problemSolutionfitReviewDateFormatted" prepend-icon="date_range"></v-text-field>
                    <v-date-picker v-model="reviewdate"> </v-date-picker>
                </v-menu>


                

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn flat @click="submit" color="primary" class="mx-2 mt-3" :loading="loading">Confirm Review Date</v-btn> -->
                <v-btn to="/bifprocessmodel7" flat color="primary" class="mx-2 mt-3" :loading="loading">Complete Step 6</v-btn>  
                
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import format from 'date-fns/format'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {},
  data() {
    return { 
    //    reviewdate: '06/03/2020',
       reviewdate: new Date('06/03/2020').toISOString().substr(0, 10),  
      doWe: false, 
      
      
      
       
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
 if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            const dateForReview = {
                problemSolutionfitReviewDateFormatted: this.problemSolutionfitReviewDateFormatted 
            }
 

            db.collection('projects').doc(this.getProjectID()).update(dateForReview).then(() => {
                    //console.log("added to db!", docRef.id)
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('addparallelinnovations')
                    ///this.$emit('firstprefdetailsconfirmed')
                });


           const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Evolution'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });

       const metric2 = {
                metrictitle: this.metrictitle2,
                metriccategory: 'Ecosystem'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric2).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });
 
 
 

             }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    problemSolutionfitReviewDateFormatted(){
        return this.reviewdate ? format(this.reviewdate, 'Do MMM YYYY'): ''
    }
  }
};
</script>

<style>
</style>
